import moment from 'moment';

const regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
const phoneReg = /1\d{10}/;
const emailReg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/;
const nameReg = /^[a-zA-Z0-9\u4E00-\u9FA5(\s?))*\(\)\（\）\·]+$/; //投保人姓名-> 汉字数字英文（）()·
const insureNameReg = /^[a-zA-Z0-9\u4E00-\u9FA5(\s?))*\(\)\（\）\·\、\，\,\/]+$/; //被保人姓名-> 汉字数字英文（）()· 、，/{}
const addressReg = /^[a-zA-Z0-9\u4E00-\u9FA5\(\)\（\）\·\，\,\[\]\【\】\-\_/s]+$/; //地址-> （）()· 【】[]，,-_ 空格{}
export default {
  data() {
    return {
      phoneReg,
      emailReg
    };
  },
  methods: {
    checkName(rule, value, callback){
      if (!value) {
        callback()
      } else {
        let result = nameReg.test(value)
        if (result) {
          callback()
        } else {
          callback([new Error('姓名由汉字数字英文括号·等组成')]);
        }
      }
    },
    checkInsureName(rule, value, callback){
      if (!value) {
        callback()
      } else {
        let result = insureNameReg.test(value)
        if (result) {
          callback()
        } else {
          callback([new Error('姓名仅支持汉字数字英文（）()· 、，/')]);
        }
      }
    },
    checkAddress(rule, value, callback){
      if (!value) {
        callback()
      } else {
        let result = addressReg.test(value)
        if (result) {
          callback()
        } else {
          callback([new Error('地址仅支持汉字数字英文（）()·【】[]，,-_ 空格')]);
        }
      }
    },
    checkIdNumber(val) {
      return regIdCard.test(val);
    },
    checkEmail(val) {
      return emailReg.test(val);
    },
    checkPhone(val) {
      return phoneReg.test(val);
    },
    resetField(mixKey) {
      const arr = mixKey.split('.');
      const formName = arr[0];
      const fieldName = arr[1];
      this[formName].setFieldsValue({
        [fieldName]: ''
      });
    },
    idNumberValidator(value, callback, formName, idTypeName) {
      // idNumber输入框验证
      if (value && this[formName].getFieldValue(idTypeName) == '1' && !this.checkIdNumber(value)) {
        callback('身份证号码不正确');
      } else {
        callback();
      }
    },
    validateAge(age1, age2, item) {
      //校验年龄是否符合规则，age1-age2,item(被保人信息)
      const dateMax = moment().subtract(age1, 'years');
      const dateMin = moment().subtract(age2, 'years');
      let between = moment(item.birthDate).isBetween(dateMin, dateMax, null, '[]');
      if (!between) {
        this.$message.warning(`${item.name}不符合投保年龄${age1}-${age2}`);
        return false;
      } else {
        return true;
      }
    },
    calcBGByIdCardNumber(idNumber) {
      // 根据身份证自动带出生日跟性别
      const year = idNumber.slice(6, 10);
      const mon = idNumber.slice(10, 12);
      const day = idNumber.slice(12, 14);
      const birth = year + '-' + mon + '-' + day;
      const sex = idNumber.slice(16, 17) % 2 == 1 ? 'M' : 'F';
      return {
        birth,
        sex,
        gender: sex
      };
    },
    handleIdCardBlurOfObj(item, listKey, list, e) {
      const value = item.idNumber;
      let invalidKey;
      if (item.idType == '1') {
        invalidKey = `idNumberInvalid`;
        if (this.checkIdNumber(value)) {
          const { birth, sex } = this.calcBGByIdCardNumber(value);
          item.gender = sex;
          item.birthDate = moment(birth);

          item[invalidKey] = false;
          e.target.style.border = ''; // 优化todo: 多次试验无果，暂时手动清除
          return;
        }
        item[invalidKey] = true;
      } else {
        item[invalidKey] = false;
      }
    },
    handleIdCardBlur(formName = 'form', idTypeName = 'idType', idNumberName = 'idNumber', gender = 'gender', birthDate = 'birthDate', idTypeValue = '1') {
      // 填完身份证根据身份证自动带出生日跟性别
      const type = this[formName].getFieldValue(idTypeName);
      const value = this[formName].getFieldValue(idNumberName);

      if (this.checkIdNumber(value) && type == idTypeValue) {
        const { birth, sex } = this.calcBGByIdCardNumber(value);
        this[formName].setFieldsValue({
          [gender]: sex,
          [birthDate]: moment(birth)
        });
      }
    },
    //融盛建工 统一社会信用代码证书和营业执照校验 start
    validateIdType(val, formKey, formName) {
      let idType = this.form.getFieldValue('idType');
      var numReg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;
      if (idType == '03') {
        //统一社会信用代码证书
        //校验1、2位
        let regArr = ['11', '12', '13', '19', '21', '29', '31', '32', '33', '34', '35', '37', '39', '41', '49', '51', '52', '53', '54', '55', '59', '61', '62', '69', '71', '72', '79', '81', '89', '91', '92', '93', 'A1', 'A9', 'G1', 'N1', 'N2', 'N3', 'N9', 'Y1'];
        //校验3、4位
        if (!numReg.test(val) || regArr.indexOf(val.substring(0, 2)) == -1 || regArr.indexOf(val.substring(2, 4)) == -1) {
          this.$message.warning('请输入正确的18位证件号码!');
          this[formName].setFieldsValue({
            [formKey]: ''
          });
        }
      } else {
        //营业执照
        let pass = this.checkBusinessNo(val);
        if (!pass) {
          this.$message.warning('请输入正确的证件号码!');
          this[formName].setFieldsValue({
            [formKey]: ''
          });
        }
      }
    },
    /*工商营业执照号*/
    checkBusinessNo(val) {
      var myRegExp = /^\d{13}(((\d{2}){0,1})|\d{5})$/, //13或15或18位数字
        myRegExp2 = /^[0-9|A-Z]{2}\d{6}[0-9|A-Z]{10}$/,
        myRegExp1 = /^([\d])\1{5}$/; //6位连续重复的数字
      var ssCode = val.substring(0, 6);
      var valid = (myRegExp.test(val) || myRegExp2.test(val)) && !myRegExp1.test(ssCode) && '0123456789,9876543210'.indexOf(ssCode) < 0;
      if (!valid) {
        return false;
      }
      return true;
    },
    //融盛建工 统一社会信用代码证书和营业执照end

    //地址校验
    validateAdress(value, formKey, formName) {
      var numReg = /^\d+$|^\d+[.]?\d+$/;
      if (numReg.test(value) || value.length < 9) {
        this.$message.warning('投保人地址长度必须大于8位并且不能全部为数字');
        this[formName].setFieldsValue({
          [formKey]: ''
        });
      } else {
        let newvalue = value.replace(/[^\x00-\xff]/g, '**');
        let length = newvalue.length;
        let byteLength = '80';
        //当填写的字节数小于设置的字节数
        if (length * 1 <= byteLength * 1) {
          return;
        }
        let limitDate = newvalue.substr(0, byteLength);
        let count = 0;
        let limitvalue = '';
        for (var i = 0; i < limitDate.length; i++) {
          var flat = limitDate.substr(i, 1);
          if (flat == '*') {
            count++;
          }
        }
        var size = 0;

        //if 基点是×; 判断在基点内有×为偶数还是奇数
        if (count % 2 == 0) {
          //当为偶数时
          size = count / 2 + (byteLength * 1 - count);
          limitvalue = value.substr(0, size);
        } else {
          //当为奇数时
          size = (count - 1) / 2 + (byteLength * 1 - count);
          limitvalue = value.substr(0, size);
        }
        this.$message.error('最大输入' + byteLength + '个字节（相当于' + byteLength / 2 + '个汉字）！');
        this[formName].setFieldsValue({
          [formKey]: limitvalue
        });
      }
    }
  }
};
